// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-menu {
  display: flex;
  justify-content: space-between; /* Space between logo and menu items */
  align-items: center;
  background-color: #fff; /* Change background to white */
  padding: 10px 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Add a subtle shadow */
}

.logo img {
  height: 36px; /* Increase the height of the logo */
  margin-right: 20px; /* Add some space between the logo and menu items */
}

.menu {
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;
}

.menu li {
  margin-left: 20px;
}

.menu a {
  color: #333; /* Dark color for menu items */
  text-decoration: none;
  font-size: 1em; /* Increase font size */
  font-weight: 500; /* Make the font weight medium */
  transition: color 0.3s ease; /* Smooth transition for color change */
}

.menu a:hover {
  color: #007BFF; /* Change color on hover */
}

.menu-toggle {
  display: none; /* Hide the checkbox */
}

.menu-icon {
  display: none; /* Hide the menu icon by default */
  cursor: pointer;
  width: 30px;
  height: 35px;
  position: relative;
}

.menu-icon span {
  display: block;
  width: 100%;
  height: 4px;
  background-color: #333;
  margin: 6px 0;
  transition: all 0.3s ease;
}

.menu-toggle:checked + .menu-icon span:nth-child(1) {
  transform: rotate(45deg);
  top: 10px;
  position: absolute;
}

.menu-toggle:checked + .menu-icon span:nth-child(2) {
  opacity: 0;
}

.menu-toggle:checked + .menu-icon span:nth-child(3) {
  transform: rotate(-45deg);
  top: 10px;
  position: absolute;
}

.menu-toggle:checked ~ .menu {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 60px;
  right: 20px;
  background: white;
  width: 200px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* Media Queries for Mobile Responsiveness */
@media (max-width: 768px) {
  .menu {
    display: none; /* Hide the menu by default on mobile */
    flex-direction: column; /* Stack menu items vertically */
    min-width: 100%; /* Full width */
    background-color: #fff; /* White background */
    position: absolute; /* Position it absolutely */
    top: 60px; /* Below the header */
    left: 0;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Add a subtle shadow */
    z-index: 9999;
  }

  .menu li {
    margin: 10px 0; /* Add margin to menu items */
    text-align: left; /* Center align menu items */
    padding: 10px 20px
  }

  .menu-toggle:checked + .menu-icon {
    position: fixed;
    top: 13px;
    right: 20px;
  }

  .menu-toggle:checked + .menu-icon span {
    background-color: #007BFF; /* Change color of the "X" */
  }

  .menu-icon {
    display: block; /* Show the menu icon on mobile */
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MainMenu.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B,EAAE,sCAAsC;EACtE,mBAAmB;EACnB,sBAAsB,EAAE,+BAA+B;EACvD,kBAAkB;EAClB,wCAAwC,EAAE,wBAAwB;AACpE;;AAEA;EACE,YAAY,EAAE,oCAAoC;EAClD,kBAAkB,EAAE,mDAAmD;AACzE;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW,EAAE,8BAA8B;EAC3C,qBAAqB;EACrB,cAAc,EAAE,uBAAuB;EACvC,gBAAgB,EAAE,gCAAgC;EAClD,2BAA2B,EAAE,uCAAuC;AACtE;;AAEA;EACE,cAAc,EAAE,0BAA0B;AAC5C;;AAEA;EACE,aAAa,EAAE,sBAAsB;AACvC;;AAEA;EACE,aAAa,EAAE,kCAAkC;EACjD,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA,4CAA4C;AAC5C;EACE;IACE,aAAa,EAAE,uCAAuC;IACtD,sBAAsB,EAAE,gCAAgC;IACxD,eAAe,EAAE,eAAe;IAChC,sBAAsB,EAAE,qBAAqB;IAC7C,kBAAkB,EAAE,2BAA2B;IAC/C,SAAS,EAAE,qBAAqB;IAChC,OAAO;IACP,wCAAwC,EAAE,wBAAwB;IAClE,aAAa;EACf;;EAEA;IACE,cAAc,EAAE,6BAA6B;IAC7C,gBAAgB,EAAE,4BAA4B;IAC9C;EACF;;EAEA;IACE,eAAe;IACf,SAAS;IACT,WAAW;EACb;;EAEA;IACE,yBAAyB,EAAE,4BAA4B;EACzD;;EAEA;IACE,cAAc,EAAE,iCAAiC;EACnD;AACF","sourcesContent":[".main-menu {\n  display: flex;\n  justify-content: space-between; /* Space between logo and menu items */\n  align-items: center;\n  background-color: #fff; /* Change background to white */\n  padding: 10px 20px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Add a subtle shadow */\n}\n\n.logo img {\n  height: 36px; /* Increase the height of the logo */\n  margin-right: 20px; /* Add some space between the logo and menu items */\n}\n\n.menu {\n  list-style: none;\n  display: flex;\n  margin: 0;\n  padding: 0;\n}\n\n.menu li {\n  margin-left: 20px;\n}\n\n.menu a {\n  color: #333; /* Dark color for menu items */\n  text-decoration: none;\n  font-size: 1em; /* Increase font size */\n  font-weight: 500; /* Make the font weight medium */\n  transition: color 0.3s ease; /* Smooth transition for color change */\n}\n\n.menu a:hover {\n  color: #007BFF; /* Change color on hover */\n}\n\n.menu-toggle {\n  display: none; /* Hide the checkbox */\n}\n\n.menu-icon {\n  display: none; /* Hide the menu icon by default */\n  cursor: pointer;\n  width: 30px;\n  height: 35px;\n  position: relative;\n}\n\n.menu-icon span {\n  display: block;\n  width: 100%;\n  height: 4px;\n  background-color: #333;\n  margin: 6px 0;\n  transition: all 0.3s ease;\n}\n\n.menu-toggle:checked + .menu-icon span:nth-child(1) {\n  transform: rotate(45deg);\n  top: 10px;\n  position: absolute;\n}\n\n.menu-toggle:checked + .menu-icon span:nth-child(2) {\n  opacity: 0;\n}\n\n.menu-toggle:checked + .menu-icon span:nth-child(3) {\n  transform: rotate(-45deg);\n  top: 10px;\n  position: absolute;\n}\n\n.menu-toggle:checked ~ .menu {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  top: 60px;\n  right: 20px;\n  background: white;\n  width: 200px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n/* Media Queries for Mobile Responsiveness */\n@media (max-width: 768px) {\n  .menu {\n    display: none; /* Hide the menu by default on mobile */\n    flex-direction: column; /* Stack menu items vertically */\n    min-width: 100%; /* Full width */\n    background-color: #fff; /* White background */\n    position: absolute; /* Position it absolutely */\n    top: 60px; /* Below the header */\n    left: 0;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Add a subtle shadow */\n    z-index: 9999;\n  }\n\n  .menu li {\n    margin: 10px 0; /* Add margin to menu items */\n    text-align: left; /* Center align menu items */\n    padding: 10px 20px\n  }\n\n  .menu-toggle:checked + .menu-icon {\n    position: fixed;\n    top: 13px;\n    right: 20px;\n  }\n\n  .menu-toggle:checked + .menu-icon span {\n    background-color: #007BFF; /* Change color of the \"X\" */\n  }\n\n  .menu-icon {\n    display: block; /* Show the menu icon on mobile */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
